import { invariant } from '@e-socna/utils';

import { AccountingContextStatus } from '../types/accounting-context.type';

import { useAccountingContext } from './useAccountingContext.hook';

export const useAccountingReadyContext = () => {
  const context = useAccountingContext();

  invariant(
    context.status === AccountingContextStatus.Ready,
    'useAccountingReadyContext requires AccountingContext to be ready',
  );

  return context;
};
